import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createAuthQuery } from '../auth-http-client';
import { createPaginatedSchema, playerDetailsSchema } from '../types';

export type GetDevicePlayersParams = {
	deviceId: number;
	name: string;
	currencies: string[];
	isConnected: boolean[];
};

export const createGetDevicePlayersQuery = () =>
	createAuthQuery({
		params: declareParams<GetDevicePlayersParams>(),
		request: {
			method: 'GET',
			url: '/player/list',
			query: ({ deviceId, name, currencies, isConnected }) => ({
				page: 0,
				limit: 100,
				deviceIds: [String(deviceId)],
				name: name || undefined,
				currencies: currencies.length === 0 ? undefined : currencies,
				isConnected: isConnected.length === 0 ? undefined : isConnected.map(String),
			}),
		},
		response: {
			contract: zodContract(createPaginatedSchema(playerDetailsSchema)),
			mapData: ({ result }) => result.rows,
		},
	});
